import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PCPWizardComponent } from './pcpwizard.component';
import { StepsModule } from 'primeng/steps';
import { PCPWizardStepComponent } from './wizardstep/pcpwizardstep.component';
import { ButtonModule } from 'primeng/button';

@NgModule({
    imports: [
        ButtonModule,
        CommonModule,
        StepsModule,
        PCPWizardComponent, PCPWizardStepComponent
    ],
    exports: [PCPWizardComponent, PCPWizardStepComponent]
})
export class PCPWizardModule { }
